/**
 * USD per 1 unit of `currency` (e.g. BRL → how many USD one BRL is worth).
 * Keys are uppercase ISO 4217 codes from Frankfurter (or DB cache).
 */
export type UsdPerUnitMap = Record<string, number>

/**
 * Build USD-per-unit map from Frankfurter-style rates where base is USD:
 * `rates.BRL` = how many BRL per 1 USD → USD per BRL = 1 / rates.BRL.
 */
export function usdPerUnitFromUsdBaseRates(rates: Record<string, number>): UsdPerUnitMap {
  const out: UsdPerUnitMap = { USD: 1 }
  for (const [quote, mult] of Object.entries(rates)) {
    const q = quote.toUpperCase()
    if (q === "USD") continue
    if (typeof mult !== "number" || !Number.isFinite(mult) || mult <= 0) continue
    out[q] = 1 / mult
  }
  return out
}

export function convertThroughUsd(
  amount: number,
  from: string,
  to: string,
  usdPerUnit: UsdPerUnitMap
): number | null {
  if (!Number.isFinite(amount)) return null
  const f = from.trim().toUpperCase()
  const t = to.trim().toUpperCase()
  if (f === t) return amount
  const usdFrom = usdPerUnit[f]
  const usdTo = usdPerUnit[t]
  if (typeof usdFrom !== "number" || typeof usdTo !== "number" || usdFrom <= 0 || usdTo <= 0) return null
  const usdAmount = amount * usdFrom
  return usdAmount / usdTo
}

export function roundMoney2(amount: number): number {
  return Math.round(amount * 100) / 100
}
